import axios from 'axios';
import globals from "../config/appconfig";
import Utils from "../utils/Utils";

export default class AssistentiService {

    static urlReport = globals["app-url-backend-report"]
    static urlReportGrafico5 = globals["app-url-backend-report"] + "/grafico5"


    static getReport() {
        return axios.get(this.urlReport)
    }

    static getReportGrafico5(params) {
        return axios.get(this.urlReportGrafico5 + Utils.addQueryParamsToRequestUrl(params))
    }

    static putReport(json) {
        return axios.put(this.urlReport, json)
    }

}
